export function formatDashboardDate(date: Date): string {
  return new Intl.DateTimeFormat(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
  }).format(date);
}

export function formatDashboardGreeting(date: Date, displayName: string | undefined): string {
  const hour = date.getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 18 ? "Good afternoon" : "Good evening";
  const firstName =
    displayName?.trim() === "CCBox Consultant" ? "Consultant" : displayName?.trim().split(/\s+/)[0];
  return firstName ? `${greeting}, ${firstName}` : greeting;
}

export function formatLastOpened(lastOpenedAt: number | null, now = Date.now()): string {
  if (lastOpenedAt === null) return "Never opened";

  const elapsedSeconds = Math.max(0, Math.floor(now / 1000) - lastOpenedAt);
  if (elapsedSeconds < 60) return "Just now";
  if (elapsedSeconds < 3_600) {
    return `${Math.floor(elapsedSeconds / 60)} min ago`;
  }
  if (elapsedSeconds < 86_400) {
    const hours = Math.floor(elapsedSeconds / 3_600);
    return `${hours} ${hours === 1 ? "hr" : "hrs"} ago`;
  }
  if (elapsedSeconds < 172_800) return "Yesterday";
  if (elapsedSeconds < 604_800) {
    return `${Math.floor(elapsedSeconds / 86_400)} days ago`;
  }
  if (elapsedSeconds < 1_209_600) return "Last week";

  return new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
  }).format(new Date(lastOpenedAt * 1000));
}
